import React from 'react';
import { colors } from '@/theme/colors';

export type InfoThickProps = {
  size?: { width: number; height: number };
  color?: string;
};

const InfoThick: React.FC<InfoThickProps> = ({
  size = { width: 24, height: 24 },
  color = colors.neutral80,
}) => {
  return (
    <svg
      width={`${size.width}px`}
      height={`${size.height}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <circle cx="12" cy="7.25" r="1.25" fill={color} />
      <path
        d="M12 11L12 17"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InfoThick;
